/* eslint-disable import/prefer-default-export */

export const setGuestSelectedStore = value => ({
  type: 'SET_GUEST_SELECTED_STORE',
  value
});

export const setGuestUserOrderMethod = value => ({
  type: 'SET_GUEST_USER_ORDER_METHOD',
  value
});

export const setGuestUserAddress = value => ({
  type: 'SET_GUEST_USER_ADDRESS',
  value
});
